import { useTranslation } from 'react-i18next'
import { type ColumnDef } from '@tanstack/react-table'
import { DeliveryStatusBadge, deliveryStatusOf } from '@/components/DeliveryStatusBadge'
import { RecentObjectsCard, type RecentSort } from '@/components/RecentObjectsCard'
import { LineItemsApi, type LineItem } from '@/services/lineItems/lineItemsApi'

const fetchRecent = async (sort: RecentSort, limit: number) =>
  (await LineItemsApi.query({ orderBy: sort, orderByDirection: 'DESCENDING', pageSize: limit })).results

/** The latest created or changed line items, with where each is in delivery. */
export function RecentLineItemsCard({ sort }: { sort: RecentSort }) {
  const { t } = useTranslation()

  const status: ColumnDef<LineItem, unknown> = {
    id: 'executionState',
    header: t('common.delivery'),
    size: 140,
    accessorFn: (li) => deliveryStatusOf(li),
    cell: ({ row }) => <DeliveryStatusBadge status={deliveryStatusOf(row.original)} />,
  }

  return (
    <RecentObjectsCard
      title={sort === 'createTime' ? t('advertisingHome.recentlyCreated') : t('advertisingHome.recentlyUpdated')}
      sort={sort}
      queryKey={['lineitems']}
      fetch={fetchRecent}
      href={(li) => `/advertising/lineitems/${li.id}`}
      sub={(li) => li.advertiserName}
      columns={[status]}
    />
  )
}
